import { render, staticRenderFns } from "./ExemptionListExportRequestsList.vue?vue&type=template&id=08dc91e7&scoped=true&"
import script from "./ExemptionListExportRequestsList.vue?vue&type=script&lang=js&"
export * from "./ExemptionListExportRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionListExportRequestsList.vue?vue&type=style&index=0&id=08dc91e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc91e7",
  null
  
)

export default component.exports